var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-form',{ref:"form",attrs:{"option":_vm.option,"append-to-body":true},on:{"submit":_vm.submit},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }